/* @flow */
import ClipboardTrigger from 'components/ClipboardTrigger.jsx';
import cx from 'classnames';
import Glyph from 'components/Glyph.jsx';
import React from 'react';
import ToastActions from 'actions/ToastActions';

import './styles/share.scss';

export default class extends React.Component {
  static propTypes = {
    text: React.PropTypes.string.isRequired,
  };

  showCopyToast = () => {
    ToastActions.showSuccessToast(
      'URL has been copied to your clipboard'
    );
  };

  render() {
    return (
      <ClipboardTrigger
        text={this.props.text}
        onCopy={this.showCopyToast}>
        <div className={cx('Share', 'ShareCopy', this.props.className)}>
          <Glyph
            className="Share-glyph ShareCopy-glyph"
            size="large"
            name="link"
          />
          <span>Copy</span>
        </div>
      </ClipboardTrigger>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ShareCopy.jsx